import { render, staticRenderFns } from "./ButtonsSettings.vue?vue&type=template&id=413d0041&scoped=true"
import script from "./ButtonsSettings.vue?vue&type=script&lang=js"
export * from "./ButtonsSettings.vue?vue&type=script&lang=js"
import style0 from "./ButtonsSettings.vue?vue&type=style&index=0&id=413d0041&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413d0041",
  null
  
)

export default component.exports